<template>
  <div id="app">
    <!-- 终端切换按钮 -->
<!--    <div class="terminal-toggle">-->
<!--      <button @click="toggleTerminal" class="toggle-btn">-->
<!--        切换到{{ status ? 'B端' : 'C端' }}-->
<!--      </button>-->
<!--      <span class="current-terminal">当前：{{ status ? 'C端' : 'B端' }}</span>-->
<!--    </div>-->

    <div v-if="!status">
      <Header />
    </div>
    <router-view />
    <div v-if="!status">
      <Footer />
    </div>
    <div v-else>
      <CFooter />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import CFooter from '@/components/cTerminal/Footer.vue'
import { setCookie, getCookie } from '@/util/cookie'
import { setRoutes } from '@/router'
import { EventBus } from '@/main'
export default {
  name: 'App',
  components: {
    Header,
    Footer,
    CFooter
  },
  data () {
    return {
      status: true // 默认展示C端
    }
  },
  mounted () {
    // 判断C端是true， B端是false
    // 从cookie获取状态，如果没有则默认为true（C端）
    const cookieStatus = getCookie('status')
    this.status = cookieStatus !== null ? cookieStatus === 'true' : true

    // 监听事件总线的切换终端事件
    EventBus.$on('toggleTerminal', this.toggleTerminal)
  },
  beforeDestroy () {
    // 移除事件监听，防止内存泄漏
    EventBus.$off('toggleTerminal', this.toggleTerminal)
  },
  methods: {
    // 切换终端类型
    async toggleTerminal () {
      const newStatus = !this.status
      this.status = newStatus
      setCookie('status', newStatus, 1) // 保存1天

      // 更新路由配置
      setRoutes(newStatus)

      // 智能路由切换
      await this.$nextTick()
      this.smartRouteSwitch(newStatus)
    },

    // 智能路由切换
    smartRouteSwitch (isCTerminal) {
      const currentRoute = this.$route.path

      if (isCTerminal) {
        // 切换到C端
        if (currentRoute === '/' || currentRoute.startsWith('/user/')) {
          // 当前路由在C端存在，无需切换

        } else {
          // 当前路由在C端不存在，跳转到C端首页
          this.$router.push('/')
        }
      } else {
        // 切换到B端
        if (currentRoute === '/' ||
            currentRoute === '/features' ||
            currentRoute === '/download' ||
            currentRoute === '/cases' ||
            currentRoute === '/pricing' ||
            currentRoute === '/personal' ||
            currentRoute === '/about' ||
            currentRoute === '/contact') {
          // 当前路由在B端存在，无需切换

        } else {
          // 当前路由在B端不存在，跳转到B端首页
          this.$router.push('/')
        }
      }
    }
  }
}
</script>

<style>
/* 终端切换按钮样式 */
.terminal-toggle {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.8);
  padding: 10px 15px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.toggle-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: background 0.3s;
}

.toggle-btn:hover {
  background: #2980b9;
}

.current-terminal {
  color: white;
  font-size: 12px;
  font-weight: 500;
}

/* message.css */
.custom-message {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%) translateY(-20px);
  opacity: 0;
  padding: 12px 20px;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  z-index: 9999;
  transition: all 0.3s ease;
  pointer-events: none;
}

.custom-message-success {
  background-color: #52c41a;
}
.custom-message-error {
  background-color: #ff4d4f;
}
.custom-message-info {
  background-color: #1890ff;
}

</style>
